<!--
 * @Description: 创建、编辑角色
 * @Author: stella
 * @Date: 2021-05-11 14:35:56
 * @LastEditTime: 2021-09-06 16:42:39
 * @LastEditors: stella
-->
<template>
  <el-dialog
    :title="type === 'add' ? '添加角色' : '编辑角色'"
    :visible.sync="isAddDialogVisible"
    :width="'500px'"
    :close-on-click-modal="false"
    append-to-body
    @close="cancelAddDialogVisible"
  >
    <div class="dialog-body addmember-body">
      <el-form
        label-width="100px"
        class="clearfix"
        ref="ruleForm"
        :model="info"
        :rules="rules"
      >
        <el-form-item label="角色名称：" prop="name">
          <el-input
            v-model.trim="info.name"
            maxlength="64"
            show-word-limit
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
        <p class="tip">最大长度64个字符，允许中文、英文字母、数字或特殊符号</p>
        <el-form-item label="角色说明：" label-width="100px">
          <el-input
            type="textarea"
            style="max-height: 100px"
            v-model.trim="info.note"
            maxlength="400"
            :rows="17"
            placeholder="请输入角色说明"
            show-word-limit
          ></el-input>
        </el-form-item>
        <p class="tip">最大长度400个字符，允许中文、英文字母、数字或特殊符号</p>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <crm-button :buttonType="'plain'" :text="'取消'" @click="cancelAddDialogVisible">
      </crm-button>
      <crm-button :text="'确定'" @click="handleEdit"></crm-button>
    </div>
  </el-dialog>
</template>
<script>
import service from "~api/backstage";
import crmButton from "@/components/base/crmButton";

export default {
  data() {
    var validatorName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入角色名称"));
      } else if (value === " ") {
        callback(new Error("请输入正确的内容"));
      } else {
        callback();
      }
    };
    return {
      info: {
        note: "",
        name: "",
        roleId: "",
      },
      type: "",
      isAddDialogVisible: false,
      rules: {
        name: [{ required: true, validator: validatorName, trigger: "blur" }],
      },
    };
  },
  components: {
    crmButton,
  },
  methods: {
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type === "add") {
            return this.addRole();
          }
          return this.editRole();
        }
        return false;
      });
    },
    addRole() {
      service.apiAddRole(this.info).then(() => {
        this.$message({
          type: "success",
          message: "新建角色成功！",
        });
        this.cancelAddDialogVisible();
        this.$emit("refresh");
      });
    },
    editRole() {
      service.apiEditRole(this.info).then(() => {
        this.$message({
          type: "success",
          message: "修改角色成功！",
        });
        this.isAddDialogVisible = false;
        this.$emit("refresh");
      });
    },
    cancelAddDialogVisible() {
      this.isAddDialogVisible = false;
      this.info = {
        note: "",
        name: "",
        roleId: "",
      };
      this.info.type = null;
      this.resetForm();
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-input__inner {
  padding-right: 50px;
}
/deep/ .el-textarea__inner::-webkit-input-placeholder {
  font-size: 12px;
}
/deep/ .el-textarea__inner::-moz-input-placeholder {
  font-size: 12px;
}
/deep/ .el-textarea__inner::-ms-input-placeholder {
  font-size: 12px;
}
/deep/ .el-form-item {
  margin-bottom: 0;
}
/deep/ .el-textarea__inner {
  max-height: 100px;
}
p.tip {
  margin: 20px 0;
  margin-left: 100px;
  font-size: 12px;
  color: #7a84b7;
}
</style>
